
import { useState, useEffect } from 'react';

export default function TestimonialsHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c60f614b8d11522f2504263a64287bbc.jpg"
          alt="Happy Insurance Clients"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6">
            Client Success Stories
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-8 leading-relaxed">
            Hear from Dallas families and businesses who found the perfect health insurance coverage with our expert guidance
          </p>
          <div className="flex items-center justify-center gap-8 text-white">
            <div className="flex items-center gap-3">
              <i className="ri-star-fill text-3xl text-secondary"></i>
              <div className="text-left">
                <div className="text-2xl font-bold">4.9/5</div>
                <div className="text-sm text-white/90">Client Rating</div>
              </div>
            </div>
            <div className="w-px h-12 bg-white/30"></div>
            <div className="flex items-center gap-3">
              <i className="ri-user-heart-line text-3xl text-secondary"></i>
              <div className="text-left">
                <div className="text-2xl font-bold">2,500+</div>
                <div className="text-sm text-white/90">Happy Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
